function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "product_rolls");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32 14.683v-9.333h-32v9.333h1.333v2.667h-1.333v5.333h1.333v4h29.334v-2.666c-0.8 0-1.334 0.533-1.334 1.333h-26.666v-2.667h29.333v-5.333h-1.333v-2.667zM30.667 21.35h-29.334v-2.667h29.334zM2.667 17.35v-2.667h26.666v2.667zM1.333 13.35v-6.667h29.334v6.667z"
});

var SvgProductRolls = function SvgProductRolls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductRolls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_rolls.356f9827.svg";
export { ForwardRef as ReactComponent };